import { useNetlifySDK } from "../use_netlify_sdk.js";
import { Card, CardTitle } from "./vendor/Card/main.js";

export type SettingsCardProps = {
  /**
   * Content to render within the element.
   *
   * Although `SurfaceRouter` does not formally enforce it, a `SurfaceRouter`'s immediate children
   * should only be `SurfaceRoute` elements.
   */
  children: React.ReactNode;
};

/**
 * TODO(ndhoule): Fix this up and document it.
 *
 * @internal
 */
export const SettingsCard = ({ children }: SettingsCardProps) => {
  const sdk = useNetlifySDK();

  return (
    <Card className="card-settings">
      <CardTitle as="h3">Connect to a {sdk.extension.name} project</CardTitle>
      {children}
    </Card>
  );
};
